module.exports = __webpack_public_path__ + "img/agriportal-logo-v2.5389853c.png";